import { atomWithStorage } from 'jotai/utils'
import { createReader } from '../../utils/atomReader'
import { ReverseLogisticProductInfo, TareOrProduct } from 'types/model'


export const reverseLogisticsSelectedItemAtom = atomWithStorage<TareOrProduct>('reverseLogisticsSelectedItem', {} as TareOrProduct)
export const reverseLogisticsSelectedItemReader = createReader(reverseLogisticsSelectedItemAtom)

export const reverseLogisticsSelectedProductAtom = atomWithStorage<ReverseLogisticProductInfo>('reverseLogisticsSelectedProduct', {} as ReverseLogisticProductInfo)
export const reverseLogisticsSelectedProductReader = createReader(reverseLogisticsSelectedProductAtom)